import Render from './Render';

interface ConcatProps {
  keys: string[] | number[];
}

class Concat extends Render {
  render = (object: {}) => {
    let result = '';
    const {keys} = this.props;
    for (const x in keys) {
      if (keys.hasOwnProperty(x)) {
        const value = object[ keys[ x ] ];
        if (value) {
          result += value + ' ';
        }
      }
    }

    return result;
  };
  private props: ConcatProps;

  public constructor(props: ConcatProps) {
    super();
    this.props = props;
  };
}

export default Concat;
